const camadas = [
    {
        codigo: 'BR_LOCALIDADE_NIVEL_1',
        nome: 'Estados',
        label: 'Estados',
        layerName: 'vega-api:br_localidade_nivel_1',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/gwc/service/wms',
        opacidade: 100
    },
    {
        codigo: 'BR_LOCALIDADE_NIVEL_2',
        nome: 'Municípios',
        label: 'Municípios',
        layerName: 'vega-api:br_localidade_nivel_2',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/gwc/service/wms',
        opacidade: 100
    },
    {
        codigo: 'IMOVEL_RURAL',
        nome: 'CAR',
        label: 'CAR',
        layerName: 'vega-api:propriedade_rural',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/gwc/service/wms',
        colorIcon: '#fff002',
        opacidade: 100
    },
    {
        codigo: 'PRODES',
        nome: 'PRODES',
        label: 'PRODES',
        layerName: 'vega-api:prodes',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        opacidade: 100
    },
    {
        codigo: 'PRODES_2008',
        nome: 'PRODES',
        label: 'PRODES',
        layerName: 'vega-api:prodes',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        opacidade: 100
    },
    {
        codigo: 'PRODES_2009',
        nome: 'PRODES',
        label: 'PRODES',
        layerName: 'vega-api:prodes',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        opacidade: 100
    },
    {
        codigo: 'PRODES_2010',
        nome: 'PRODES',
        label: 'PRODES',
        layerName: 'vega-api:prodes',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        opacidade: 100
    },
    {
        codigo: 'PRODES_2011',
        nome: 'PRODES',
        label: 'PRODES',
        layerName: 'vega-api:prodes',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        opacidade: 100
    },
    {
        codigo: 'PRODES_2012',
        nome: 'PRODES',
        label: 'PRODES',
        layerName: 'vega-api:prodes',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        opacidade: 100
    },
    {
        codigo: 'PRODES_2013',
        nome: 'PRODES',
        label: 'PRODES',
        layerName: 'vega-api:prodes',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        opacidade: 100
    },
    {
        codigo: 'PRODES_2014',
        nome: 'PRODES',
        label: 'PRODES',
        layerName: 'vega-api:prodes',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        opacidade: 100
    },
    {
        codigo: 'PRODES_2015',
        nome: 'PRODES',
        label: 'PRODES',
        layerName: 'vega-api:prodes',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        opacidade: 100
    },
    {
        codigo: 'PRODES_2016',
        nome: 'PRODES',
        label: 'PRODES',
        layerName: 'vega-api:prodes',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        opacidade: 100
    },
    {
        codigo: 'PRODES_2017',
        nome: 'PRODES',
        label: 'PRODES',
        layerName: 'vega-api:prodes',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        opacidade: 100
    },
    {
        codigo: 'PRODES_2018',
        nome: 'PRODES',
        label: 'PRODES',
        layerName: 'vega-api:prodes',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        opacidade: 100
    },
    {
        codigo: 'PRODES_2019',
        nome: 'PRODES',
        label: 'PRODES',
        layerName: 'vega-api:prodes',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        opacidade: 100
    },
    {
        codigo: 'PRODES_2020',
        nome: 'PRODES',
        label: 'PRODES',
        layerName: 'vega-api:prodes',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        opacidade: 100
    },
    {
        codigo: 'PRODES_2021',
        nome: 'PRODES',
        label: 'PRODES',
        layerName: 'vega-api:prodes',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        opacidade: 100
    },
    {
        codigo: 'PRODES_2022',
        nome: 'PRODES',
        label: 'PRODES',
        layerName: 'vega-api:prodes',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        opacidade: 100
    },
    {
        codigo: 'PRODES_2023',
        nome: 'PRODES',
        label: 'PRODES',
        layerName: 'vega-api:prodes',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        opacidade: 100
    },
    {
        codigo: 'PRODES_2024',
        nome: 'PRODES',
        label: 'PRODES',
        layerName: 'vega-api:prodes',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        opacidade: 100
    },
    {
        codigo: 'PRODES_PANTANAL',
        nome: 'PRODES Pantanal',
        label: 'PRODES Pantanal',
        layerName: 'vega-api:prodes_pantanal',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        opacidade: 100,
        inspecionar: true
    },
    {
        codigo: 'PRODES_MATA_ATLANTICA',
        nome: 'PRODES Mata Atlântica',
        label: 'PRODES Mata Atlântica',
        layerName: 'vega-api:prodes_mata_atlantica',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        opacidade: 100,
        inspecionar: true
    },
    {
        codigo: 'PRODES_PAMPA',
        nome: 'PRODES Pampa',
        label: 'PRODES Pampa',
        layerName: 'vega-api:prodes_pampa',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        opacidade: 100,
        inspecionar: true
    },
    {
        codigo: 'PRODES_CAATINGA',
        nome: 'PRODES Caatinga',
        label: 'PRODES Caatinga',
        layerName: 'vega-api:prodes_caatinga',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        opacidade: 100,
        inspecionar: true
    },
    {
        codigo: 'PRODES_RESIDUOS',
        nome: 'PRODES Resíduos Amazônia Legal',
        label: 'PRODES Resíduos Amazônia Legal',
        layerName: 'vega-api:prodes_residuos',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        opacidade: 100,
        inspecionar: true
    },
    {
        codigo: 'PRODES_RESIDUOS_AMAZONIA',
        nome: 'PRODES Resíduos Amazônia',
        label: 'PRODES Resíduos Amazônia',
        layerName: 'vega-api:prodes_residuos_amazonia',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        opacidade: 100,
        inspecionar: true
    },
    {
        codigo: 'PRODES_RESIDUOS_CAATINGA',
        nome: 'PRODES Resíduos Caatinga',
        label: 'PRODES Resíduos Caatinga',
        layerName: 'vega-api:prodes_residuos_caatinga',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        opacidade: 100,
        inspecionar: true
    },
    {
        codigo: 'PRODES_RESIDUOS_CERRADO',
        nome: 'PRODES Resíduos Cerrado',
        label: 'PRODES Resíduos Cerrado',
        layerName: 'vega-api:prodes_residuos_cerrado',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        opacidade: 100,
        inspecionar: true
    },
    {
        codigo: 'PRODES_RESIDUOS_MATA_ATLANTICA',
        nome: 'PRODES Resíduos Mata Atlântica',
        label: 'PRODES Resíduos Mata Atlântica',
        layerName: 'vega-api:prodes_residuos_mata_atlantica',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        opacidade: 100,
        inspecionar: true
    },
    {
        codigo: 'PRODES_RESIDUOS_PAMPA',
        nome: 'PRODES Resíduos Pampa',
        label: 'PRODES Resíduos Pampa',
        layerName: 'vega-api:prodes_residuos_pampa',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        opacidade: 100,
        inspecionar: true
    },
    {
        codigo: 'PRODES_RESIDUOS_PANTANAL',
        nome: 'PRODES Resíduos Pantanal',
        label: 'PRODES Resíduos Pantanal',
        layerName: 'vega-api:prodes_residuos_pantanal',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        opacidade: 100,
        inspecionar: true
    },
    {
        codigo: 'TERRA_INDIGENA',
        nome: 'Terras Indígenas',
        label: 'Terras Indígenas',
        layerName: 'vega-api:terra_indigena',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        colorIcon: '#e69138',
        opacidade: 100
    },
    {
        codigo: 'UNIDADE_CONSERVACAO_US',
        nome: 'Unidades de conservação de uso sustentável',
        label: 'Unidades de conservação de uso sustentável',
        layerName: 'vega-api:unidade_conservacao_uso_sustentavel',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        colorIcon: '#f6630b',
        opacidade: 100
    },
    {
        codigo: 'UNIDADE_CONSERVACAO_PI',
        nome: 'Unidades de conservação de proteção integral',
        label: 'Unidades de conservação de proteção integral',
        layerName: 'vega-api:unidade_conservacao_protecao_integral',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        opacidade: 100
    },
    {
        codigo: 'AREA_EMBARGADA',
        nome: 'Áreas Embargadas (IBAMA)',
        label: 'Áreas Embargadas (IBAMA)',
        layerName: 'vega-api:area_embargada',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        colorIcon: '#b21d11',
        opacidade: 100
    },
    {
        codigo: 'AREA_EMBARGADA_IBAMA_POLIGONO_PAMGIA',
        nome: 'Área Embargada (IBAMA) - PAMGIA',
        label: 'Área Embargada (IBAMA) - PAMGIA',
        layerName: 'vega-api:area_embargada_ibama_poligono_pamgia',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        colorIcon: '#b21d11',
        opacidade: 100
    },
    {
        codigo: 'AREA_EMBARGADA_RO',
        nome: 'Área Embargada (SEDAM-RO)-Polígono',
        label: 'Área Embargada (SEDAM-RO)-Polígono',
        layerName: 'vega-api:area_embargada_ro',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        colorIcon: '#b21d11',
        opacidade: 100
    },
    {
        codigo: 'AREA_EMBARGADA_RO_PONTO',
        nome: 'Área Embargada (SEDAM-RO)-Ponto',
        label: 'Área Embargada (SEDAM-RO)-Ponto',
        layerName: 'vega-api:area_embargada_ro_ponto',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        colorIcon: '#b21d11',
        opacidade: 100
    },
    {
        codigo: 'LISTA_AREA_EMBARGADA',
        nome: 'Áreas embargadas Ibama - Lista',
        label: 'Áreas embargadas Ibama - Lista',
        layerName: 'vega-api:lista_area_embargada_ibama',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        colorIcon: '#b21d11',
        opacidade: 100,
        inspecionar: true
    },
    {
        codigo: 'AREA_EMBARGADA_SEMA_MT',
        nome: 'Áreas Embargadas (SEMA-MT)',
        label: 'Áreas Embargadas (SEMA-MT)',
        layerName: 'vega-api:area_embargada_semas_mt',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        colorIcon: '#d100c5',
        opacidade: 100
    },
    {
        codigo: 'LISTA_AREA_EMBARGADA_SEMA_MT',
        nome: 'Lista de Áreas embargadas SEMA-MT',
        label: 'Lista de Áreas embargadas SEMA-MT',
        layerName: 'vega-api:area_embargada_sema_mt_lista',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        colorIcon: '#b21d19',
        opacidade: 100,
        inspecionar: true
    },
    {
        codigo: 'AREA_EMBARGADA_SIGA_SEMA_MT',
        nome: 'Áreas Embargadas SIGA/SEMA-MT',
        label: 'Áreas Embargadas SIGA/SEMA-MT',
        layerName: 'vega-api:area_embargada_sema_siga_mt',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        colorIcon: '#70cee4',
        opacidade: 100
    },
    {
        codigo: 'AREA_EMBARGADA_SIGA_MT_POLIGONO',
        nome: 'Áreas Embargadas SIGA-MT - Polígono',
        label: 'Áreas Embargadas SIGA-MT - Polígono',
        layerName: 'vega-api:area_embargada_siga_mt_poligono',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        colorIcon: '#70cee4',
        opacidade: 100
    },
    {
        codigo: 'AREA_EMBARGADA_SIGA_MT_PONTO',
        nome: 'Áreas Embargadas SIGA-MT - Ponto',
        label: 'Áreas Embargadas SIGA-MT - Ponto',
        layerName: 'vega-api:area_embargada_siga_mt_ponto',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        colorIcon: '#70cee4',
        opacidade: 100
    },
    {
        codigo: 'AREA_EMBARGADA_ICMBIO',
        nome: 'Área embargada ICMBio',
        label: 'Área embargada ICMBio',
        layerName: 'vega-api:area_embargada_icmbio',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        colorIcon: '#c0fd79',
        opacidade: 100
    },

    {
        codigo: 'DESMATAMENTO_MAPBIOMAS',
        nome: 'Desmatamento MapBiomas',
        label: 'Desmatamento MapBiomas',
        layerName: 'vega-api:desmatamento_mapbiomas',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/gwc/service/wms',
        colorIcon: '#ff0000',
        opacidade: 100
    },

    {
        codigo: 'PRODES_CERRADO',
        nome: 'PRODES Cerrado',
        label: 'PRODES Cerrado',
        layerName: 'vega-api:prodes_cerrado',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        opacidade: 100
    },
    {
        codigo: 'DETER_AMAZONIA',
        nome: 'DETER Amazônia',
        label: 'DETER Amazônia',
        layerName: 'vega-api:deter_amazonia',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        opacidade: 100
    },
    {
        codigo: 'DETER_CERRADO',
        nome: 'DETER Cerrado',
        label: 'DETER Cerrado',
        layerName: 'vega-api:deter_cerrado',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        opacidade: 100
    },
    {
        codigo: 'LDI',
        nome: 'LDI',
        label: 'LDI',
        layerName: 'vega-api:ldi',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        colorIcon: '#70cee4',
        opacidade: 100
    },
    {
        codigo: 'CONTROLE_DESMATAMENTO_AMAZONIA_PONTOS',
        nome: 'Controle Desmatamento Amazônia - pontos',
        label: 'Controle Desmatamento Amazônia - pontos',
        layerName: 'vega-api:moratoria_soja_pontos',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        colorIcon: '#fff2cc',
        opacidade: 100
    },
    {
        codigo: 'HIDROGRAFIA',
        nome: 'Hidrografia',
        label: 'Hidrografia',
        layerName: 'vega-api:hidrografia',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/gwc/service/wms',
        opacidade: 100
    },
    // {
    //     codigo: 'TERRITORIOS',
    //     nome: 'Territórios',
    //     label: 'Territórios',
    //     layerName: process.env.VUE_APP_LAYER_TERRITORIO + ':territorio',
    //     ativo: false,
    //     local: true,
    //     path: process.env.VUE_APP_LAYER_TERRITORIO + '/wms',
    //     colorIcon: '#0bfb00',
    //     opacidade: 100
    // },
    {
        codigo: 'BIOMAS',
        nome: 'Biomas',
        label: 'Biomas',
        layerName: 'vega-api:biomas',
        styleName: 'vega-api:biomas-classificados',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/gwc/service/wms',
        colorIcon: '#8be365',
        opacidade: 100,
        subtitle: [
            {
                name: 'Amazonia',
                colorIcon: '#42a72a',
                opacidade: 100
            },
            {
                name: 'Cerrado',
                colorIcon: '#fde8a0',
                opacidade: 100
            },
            {
                name: 'Caatinga',
                colorIcon: '#f69f8c',
                opacidade: 100
            },
            {
                name: 'Pantanal',
                colorIcon: '#a3a189',
                opacidade: 100
            },
            {
                name: 'Mata Atlântica',
                colorIcon: '#fbe1fe',
                opacidade: 100
            },
            {
                name: 'Pampa',
                colorIcon: '#d3ecb5',
                opacidade: 100
            }
        ]
    },
    {
        codigo: 'COBERTURA_SOLO_MAPBIOMAS',
        nome: 'Cobertura do Solo - Mapbiomas',
        label: 'Cobertura do Solo - Mapbiomas',
        layerName: 'vega-api:cobertura_solo_map_biomas_2021',
        styleName: 'vega-api:cobertura_solo_mapbiomas',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/gwc/service/wms',
        colorIcon: '#8be365',
        opacidade: 100,
        subtitle: [
            {
                name: 'Afloramento Rochoso',
                colorIcon: '#FF8C00',
                opacidade: 100
            },
            {
                name: 'Agricultura',
                colorIcon: '#E974ED',
                opacidade: 100
            },
            {
                name: 'Algodão beta',
                colorIcon: '#660066',
                opacidade: 100
            },
            {
                name: 'Apicum',
                colorIcon: '#968C46',
                opacidade: 100
            },
            {
                name: 'Aquicultura',
                colorIcon: '#29EEE4',
                opacidade: 100
            },
            {
                name: 'Área Urbanizada',
                colorIcon: '#AF2A2A',
                opacidade: 100
            },
            {
                name: 'Arroz',
                colorIcon: '#982C9E',
                opacidade: 100
            },
            {
                name: 'Café',
                colorIcon: '#CCA0D4',
                opacidade: 100
            },
            {
                name: 'Citrus',
                colorIcon: '#D082DE',
                opacidade: 100
            },
            {
                name: 'Campo Alagado e Área Pantanosa',
                colorIcon: '#45C2A5',
                opacidade: 100
            },
            {
                name: 'Cana',
                colorIcon: '#C27BA0',
                opacidade: 100
            },
            {
                name: 'Formação Campestre',
                colorIcon: '#B8AF4F',
                opacidade: 100
            },
            {
                name: 'Formação Florestal',
                colorIcon: '#006400',
                opacidade: 100
            },
            {
                name: 'Formação Savânica',
                colorIcon: '#32CD32',
                opacidade: 100
            },
            {
                name: 'Lavoura Perene',
                colorIcon: '#F3B4F1',
                opacidade: 100
            },
            {
                name: 'Lavoura Temporária',
                colorIcon: '#D5A6BD',
                opacidade: 100
            },
            {
                name: 'Mangue',
                colorIcon: '#687537',
                opacidade: 100
            },
            {
                name: 'Mineração',
                colorIcon: '#8A2BE2',
                opacidade: 100
            },
            {
                name: 'Mosaico de Usos',
                colorIcon: '#FFEFC3',
                opacidade: 100
            },
            {
                name: 'Outras Áreas não Vegetadas',
                colorIcon: '#FF99FF',
                opacidade: 100
            },
            {
                name: 'Outras Formações não Florestais',
                colorIcon: '#BDB76B',
                opacidade: 100
            },
            {
                name: 'Outras Lavouras Perenes',
                colorIcon: '#CD49E4',
                opacidade: 100
            },
            {
                name: 'Outras Lavouras Temporárias',
                colorIcon: '#E787F8',
                opacidade: 100
            },
            {
                name: 'Pastagem',
                colorIcon: '#FFD966',
                opacidade: 100
            },
            {
                name: 'Praia Duna e Areal',
                colorIcon: '#DD7E6B',
                opacidade: 100
            },
            {
                name: 'Restinga Arborizada',
                colorIcon: '#6B9932',
                opacidade: 100
            },
            {
                name: 'Restinga Herbácea',
                colorIcon: '#66FFCC',
                opacidade: 100
            },
            {
                name: 'Rio Lago e Oceano',
                colorIcon: '#0000FF',
                opacidade: 100
            },
            {
                name: 'Silvicultura monocultura',
                colorIcon: '#935132',
                opacidade: 100
            },
            {
                name: 'Soja',
                colorIcon: '#C59FF4',
                opacidade: 100
            }
        ]
    },
    {
        codigo: 'AREA_PLANTADA_SOJA_CAR_MAPBIOMAS',
        nome: 'Área de soja - coleção 8 - Mapbiomas',
        label: 'Área de soja - coleção 8 - Mapbiomas',
        layerName: 'vega-api:cobertura_solo_map_biomas_2021',
        styleName: 'soja_mapbiomas_2021',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        colorIcon: '#C59FF4',
        opacidade: 100
    },
    {
        codigo: 'INCRA_SIGEF_PRIVADO',
        nome: 'INCRA/SIGEF(Privado)',
        label: 'INCRA/SIGEF(Privado)',
        layerName: 'vega-api:sigef_privado',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/gwc/service/wms',
        colorIcon: '#b45f05',
        opacidade: 100
    },
    {
        codigo: 'INCRA_SIGEF_PUBLICO',
        nome: 'INCRA/sigef (Público)',
        label: 'INCRA/sigef (Público)',
        layerName: 'vega-api:sigef_publico',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/gwc/service/wms',
        colorIcon: '#9e7f05',
        opacidade: 100
    },
    {
        codigo: 'INCRA_ASSENTAMENTOS',
        nome: 'Assentamento Rural',
        label: 'Assentamento Rural',
        layerName: 'vega-api:assentamentos',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/gwc/service/wms',
        colorIcon: '#e5be8f',
        opacidade: 100
    },
    {
        codigo: 'INCRA_QUILOMBOLAS',
        nome: 'Comunidades quilombolas',
        label: 'Comunidades quilombolas',
        layerName: 'vega-api:quilombolas_incra',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/gwc/service/wms',
        colorIcon: '#c1b0ab',
        opacidade: 100
    },
    {
        codigo: 'FAIXA_FRONTEIRA',
        nome: 'Faixa de fronteira',
        label: 'Faixa de fronteira',
        layerName: 'vega-api:faixa_fronteira',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/gwc/service/wms',
        colorIcon: '#E06666',
        opacidade: 100
    },
    {
        codigo: 'POC_AREA_PLANTADA_GAMELEIRA',
        nome: 'Área plantada Gameleira',
        label: 'Área plantada Gameleira',
        layerName: 'pocs:car_plantio_gameleira',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/pocs/wms',
        colorIcon: '#6AA84F',
        opacidade: 100
    },
    {
        codigo: 'AREA_EMBARGADA_GOIAS',
        nome: 'Áreas Embargadas - GO',
        label: 'Áreas Embargadas - GO',
        layerName: 'vega-api:area_embargada_goias',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/gwc/service/wms',
        colorIcon: '#99357B',
        opacidade: 100
    },
    {
        codigo: 'AREA_EMBARGADA_PIAUI',
        nome: 'Áreas Embargadas Piauí',
        label: 'Áreas Embargadas Piauí',
        layerName: 'vega-api:area_embargada_piaui',
        ativo: false,
        checkbox: true,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/gwc/service/wms',
        colorIcon: '#70cee4',
        opacidade: 100,
        inspecionar: true
    },
    {
        codigo: 'PLANTIO_SOJA',
        nome: 'Plantio de soja',
        label: 'Plantio de soja',
        layerName: 'pocs:areas_plantio_soja_2020',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/pocs/wms',
        colorIcon: '#6aa84f',
        opacidade: 100
    },
    {
        codigo: 'QUEIMADAS',
        nome: 'Queimadas',
        label: 'Queimadas',
        layerName: 'vega-api:queimadas',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/gwc/service/wms',
        colorIcon: '#ff0000',
        opacidade: 100
    },
    {
        codigo: 'CONTROLE_DESMATAMENTO_AMAZONIA',
        nome: 'Controle Desmatamento Amazônia - polígonos',
        label: 'Controle Desmatamento Amazônia - polígonos',
        layerName: 'vega-api:moratoria_soja_poligonos',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        colorIcon: '#e19418',
        opacidade: 100
    },
    {
        codigo: 'SITIOS_ARQUEOLOGICOS',
        nome: 'Sítios Arqueológicos',
        label: 'Sítios Arqueológicos',
        layerName: 'vega-api:sitios_arqueologicos',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        colorIcon: '#b9770e',
        opacidade: 100
    },
    {
        codigo: 'FUNDACAO_PALMARES',
        nome: 'Fundação Palmares',
        label: 'Fundação Palmares',
        layerName: 'vega-api:fundacao_palmares',
        checkbox: true,
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        colorIcon: '#674ea7',
        opacidade: 100,
        inspecionar: true
    },
    {
        codigo: 'AREA_EMBARGADA_SEDAM_RO',
        nome: 'Áreas Embargadas (SEDAM-RO)',
        label: 'Áreas Embargadas (SEDAM-RO)',
        layerName: 'vega-api:area_embargada_sedam_ro',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        colorIcon: '#ff0000',
        opacidade: 100
    },
    {
        codigo: 'AREA_EMBARGADA_GDF',
        nome: 'Áreas Embargadas - Distrito Federal (GDF)',
        label: 'Áreas Embargadas - Distrito Federal (GDF)',
        layerName: 'vega-api:area_embargada_gdf',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api-homolog/wms',
        colorIcon: '#ff0000',
        opacidade: 100
    },
    {
        codigo: 'CONTROLE_DESMATAMENTO_AMAZONIA_CONSOLIDADA',
        nome: 'Controle Desmatamento Amazônia - Consolidada',
        label: 'Controle Desmatamento Amazônia - Consolidada',
        layerName: 'vega-api:moratoria_soja_consolidada',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        colorIcon: '#fff2cc',
        opacidade: 100
    },
    {
        codigo: 'AUTO_INFRACAO_IPAAM',
        nome: 'Auto de Infração IPAAM',
        label: 'Auto de Infração IPAAM',
        layerName: 'vega-api:auto_de_infracao_ipaam',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        colorIcon: '#FFFF00',
        opacidade: 100
    },
    {
        codigo: 'AUTOS_EMBARGOS_IPAAM_POL',
        nome: 'Avisos de embargo - IPAAM',
        label: 'Avisos de embargo - IPAAM',
        layerName: 'vega-api:autos_embargos_ipaam_pol',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        colorIcon: '#FFFF00',
        opacidade: 100
    },
    {
        codigo: 'FLORESTAS_PUBLICAS',
        nome: 'Florestas Públicas',
        label: 'Florestas Públicas',
        layerName: 'vega-api:florestas_publicas',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        colorIcon: '#347474',
        opacidade: 100
    },
    {
        nome: 'Certificações',
        ativo: false,
        colorIcon: '#935132',
        grupo: [
            {
                codigo: 'DESMATAMENTO_2007',
                nome: 'Desmatamento 2007',
                label: 'Desmatamento 2007',
                layerName: 'vega-api:desmatamento',
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#ff0000',
                opacidade: 100
            },
            {
                codigo: 'DESMATAMENTO_2008',
                nome: 'Desmatamento 2008',
                label: 'Desmatamento 2008',
                layerName: 'vega-api:desmatamento_2008',
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#ff0000',
                opacidade: 100
            },
            {
                codigo: 'DESMATAMENTO_2009',
                nome: 'Desmatamento 2009',
                label: 'Desmatamento 2009',
                layerName: 'vega-api:desmatamento_2009',
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#ff0000',
                opacidade: 100
            },
            {
                codigo: 'DESMATAMENTO_2011',
                nome: 'Desmatamento 2011',
                label: 'Desmatamento 2011',
                layerName: 'vega-api:desmatamento_2011',
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#ff0000',
                opacidade: 100
            },
            {
                codigo: 'DESMATAMENTO_2013',
                nome: 'Desmatamento 2013',
                label: 'Desmatamento 2013',
                layerName: 'vega-api:desmatamento_2013',
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#ff0000',
                opacidade: 100
            },
            {
                codigo: 'DESMATAMENTO_2015',
                nome: 'Desmatamento 2015',
                label: 'Desmatamento 2015',
                layerName: 'vega-api:desmatamento_2015',
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#ff0000',
                opacidade: 100
            },
            {
                codigo: 'DESMATAMENTO_2016',
                nome: 'Desmatamento 2016',
                label: 'Desmatamento 2016',
                layerName: 'vega-api:desmatamento_2016',
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#ff0000',
                opacidade: 100
            },
            {
                codigo: 'DESMATAMENTO_2018',
                nome: 'Desmatamento 2018',
                label: 'Desmatamento 2018',
                layerName: 'vega-api:desmatamento_2018',
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#ff0000',
                opacidade: 100
            },
            {
                codigo: 'DESMATAMENTO_2020',
                nome: 'Desmatamento 2020',
                label: 'Desmatamento 2020',
                layerName: 'vega-api:desmatamento_2020',
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#ff0000',
                opacidade: 100
            },
            {
                codigo: 'DESMATAMENTO_2021',
                nome: 'Desmatamento 2021',
                label: 'Desmatamento 2021',
                layerName: 'vega-api:desmatamento_2021',
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#ff0000',
                opacidade: 100
            },
            {
                codigo: 'DESMATAMENTO_2022',
                nome: 'Desmatamento 2022',
                label: 'Desmatamento 2022',
                layerName: 'vega-api:desmatamento_2022',
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#ff0000',
                opacidade: 100
            },
            {
                codigo: 'DESMATAMENTO_2023',
                nome: 'Desmatamento 2023',
                label: 'Desmatamento 2023',
                layerName: 'vega-api:desmatamento_2023',
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#ff0000',
                opacidade: 100
            },
            {
                codigo: 'AREA_PLANTADA_VEGETACAO_NATIVA_2022_MILHO',
                nome: 'Área Plantada (2022/2023 - Milho)',
                label: 'Área Plantada (2022/2023 - Milho)',
                layerName: 'vega-api:area_plantada_soja_milho_safra_2022',
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#ffd866',
                opacidade: 100,
                cql_filter: "cultura='MILHO'",
                styleName: 'milho'
            },
            {
                codigo: 'AREA_PLANTADA_VEGETACAO_NATIVA_2022_SOJA',
                nome: 'Área Plantada (2022/2023 - Soja)',
                label: 'Área Plantada (2022/2023 - Soja)',
                layerName: 'vega-api:area_plantada_soja_milho_safra_2022',
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#6aa84f',
                opacidade: 100,
                cql_filter: "cultura='SOJA'",
                styleName: 'soja'
            },
            {
                codigo: 'ELEGIBILIDADE_RENOVABIO_ELEGIVEL_RS_2024',
                nome: 'CARs Elegíveis - RS',
                label: 'CARs Elegíveis - RS',
                layerName: 'vega-api:elegibilidade_renovabio_elegivel_rs_2024',
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#9ef42f',
                opacidade: 100
            },
            {
                codigo: 'ELEGIBILIDADE_RENOVABIO_NAO_ELEGIVEL_RS_2024',
                nome: 'CARs Inelegíveis - RS',
                label: 'CARs Inelegíveis - RS',
                layerName:
                    'vega-api:elegibilidade_renovabio_nao_elegivel_rs_2024',
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#f45f2f',
                opacidade: 100
            },
            {
                codigo: 'ELEGIBILIDADE_RENOVABIO_ELEGIVEL_PR_2024',
                nome: 'CARs Elegíveis - PR',
                label: 'CARs Elegíveis - PR',
                layerName: 'vega-api:elegibilidade_renovabio_elegivel_pr_2024',
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#9ef42f',
                opacidade: 100
            },
            {
                codigo: 'ELEGIBILIDADE_RENOVABIO_NAO_ELEGIVEL_PR_2024',
                nome: 'CARs Inelegíveis - PR',
                label: 'CARs Inelegíveis - PR',
                layerName:
                    'vega-api:elegibilidade_renovabio_nao_elegivel_pr_2024',
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#f45f2f',
                opacidade: 100
            },
            {
                codigo: 'TREE_CANOPY_COVER_TCC',
                nome: 'TREE_CANOPY_COVER_TCC',
                label: 'Tree canopy cover (TCC)',
                layerName: 'vega-api:tree_canopy_cover',
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#e69138',
                opacidade: 100
            }
        ]
    },
    {
        nome: 'Red Flag',
        ativo: false,
        colorIcon: '#FA0902',
        grupo: [
            {
                codigo: 'RED_YELLOW_FLAG',
                nome: 'Desmatamento 2020',
                label: 'Desmatamento 2020',
                layerName: 'vega-api-homolog:red_yellow_flag',
                ativo: true,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api-homolog/wms',
                colorIcon: '#FA0902',
                opacidade: 100,
                cql_filter: "ano_desmatamento='2020' AND flag='Red'"
            },
            {
                codigo: 'RED_YELLOW_FLAG',
                nome: 'Desmatamento 2021',
                label: 'Desmatamento 2021',
                layerName: 'vega-api-homolog:red_yellow_flag',
                ativo: true,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api-homolog/wms',
                colorIcon: '#FA0902',
                opacidade: 100,
                cql_filter: "ano_desmatamento='2021' AND flag='Red'"
            },
            {
                codigo: 'RED_YELLOW_FLAG',
                nome: 'Desmatamento 2022',
                label: 'Desmatamento 2022',
                layerName: 'vega-api-homolog:red_yellow_flag',
                ativo: true,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api-homolog/wms',
                colorIcon: '#FA0902',
                opacidade: 100,
                cql_filter: "ano_desmatamento='2022' AND flag='Red'"
            },
            {
                codigo: 'RED_YELLOW_FLAG',
                nome: 'Desmatamento 2023',
                label: 'Desmatamento 2023',
                layerName: 'vega-api-homolog:red_yellow_flag',
                ativo: true,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api-homolog/wms',
                colorIcon: '#FA0902',
                opacidade: 100,
                cql_filter: "ano_desmatamento='2023' AND flag='Red'"
            },
            {
                codigo: 'RED_YELLOW_FLAG',
                nome: 'Desmatamento 2024',
                label: 'Desmatamento 2024',
                layerName: 'vega-api-homolog:red_yellow_flag',
                ativo: true,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api-homolog/wms',
                colorIcon: '#FA0902',
                opacidade: 100,
                cql_filter: "ano_desmatamento='2024' AND flag='Red'"
            }
        ]
    },
    {
        nome: 'Yellow Flag',
        ativo: false,
        colorIcon: '#FFCC00',
        grupo: [
            {
                codigo: 'RED_YELLOW_FLAG',
                nome: 'Desmatamento 2020',
                label: 'Desmatamento 2020',
                layerName: 'vega-api-homolog:red_yellow_flag',
                ativo: true,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api-homolog/wms',
                colorIcon: '#FFCC00',
                opacidade: 100,
                cql_filter: "ano_desmatamento='2020' AND flag='Yellow'"
            },
            {
                codigo: 'RED_YELLOW_FLAG',
                nome: 'Desmatamento 2021',
                label: 'Desmatamento 2021',
                layerName: 'vega-api-homolog:red_yellow_flag',
                ativo: true,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api-homolog/wms',
                colorIcon: '#FFCC00',
                opacidade: 100,
                cql_filter: "ano_desmatamento='2021' AND flag='Yellow'"
            },
            {
                codigo: 'RED_YELLOW_FLAG',
                nome: 'Desmatamento 2022',
                label: 'Desmatamento 2022',
                layerName: 'vega-api-homolog:red_yellow_flag',
                ativo: true,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api-homolog/wms',
                colorIcon: '#FFCC00',
                opacidade: 100,
                cql_filter: "ano_desmatamento='2022' AND flag='Yellow'"
            },
            {
                codigo: 'RED_YELLOW_FLAG',
                nome: 'Desmatamento 2023',
                label: 'Desmatamento 2023',
                layerName: 'vega-api-homolog:red_yellow_flag',
                ativo: true,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api-homolog/wms',
                colorIcon: '#FFCC00',
                opacidade: 100,
                cql_filter: "ano_desmatamento='2023' AND flag='Yellow'"
            },
            {
                codigo: 'RED_YELLOW_FLAG',
                nome: 'Desmatamento 2024',
                label: 'Desmatamento 2024',
                layerName: 'vega-api-homolog:red_yellow_flag',
                ativo: true,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api-homolog/wms',
                colorIcon: '#FFCC00',
                opacidade: 100,
                cql_filter: "ano_desmatamento='2024' AND flag='Yellow'"
            }
        ]
    },
    {
        nome: 'Paraguai',
        ativo: false,
        colorIcon: '#935132',
        grupo: [
            {
                codigo: 'PY_LOCALIDADE_NIVEL_1',
                nome: 'Departamentos Paraguai',
                label: 'Departamentos Paraguai',
                layerName: 'vega-api:py_localidade_nivel_1',
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                opacidade: 100,
                inspecionar: true
            },
            {
                codigo: 'PY_LOCALIDADE_NIVEL_2',
                nome: 'Localidades Paraguai',
                label: 'Localidades Paraguai',
                layerName: 'vega-api:py_localidade_nivel_2',
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                opacidade: 100,
                inspecionar: true
            },
            {
                codigo: 'PASTIZAL_PARAGUAI',
                nome: 'PASTIZAL_PARAGUAI',
                label: 'Pastagens',
                layerName: 'vega-api:pastizal_paraguai',
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#e69138',
                opacidade: 100
            },
            {
                codigo: 'PASTIZAL_INUNDABLE_PARAGUAI',
                nome: 'PASTIZAL_INUNDABLE_PARAGUAI',
                label: 'Pastagens Inundavel Paraguai',
                layerName: 'vega-api:pastizal_inundable_paraguai',
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#e69138',
                opacidade: 100
            },
            {
                codigo: 'PASTIZAL_PARAGUAI',
                nome: 'PASTIZAL_PARAGUAI',
                label: 'Pastagens',
                layerName: 'vega-api:pastizal_paraguai',
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#e69138',
                opacidade: 100
            },
            {
                codigo: 'AREAS_SILVESTRES_PROTEGIDAS_PARAGUAI',
                nome: 'Áreas Silvestres Protegidas do Paraguai',
                label: 'Áreas Silvestres Protegidas do Paraguai',
                layerName: 'vega-api:areas_protegidas_paraguai',
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                opacidade: 100,
                inspecionar: true
            }
        ]
    },
    {
        codigo: 'TERMO_EMBARGO_IPAAM',
        nome: 'Termo de embargo - IPAAM',
        label: 'Termo de embargo - IPAAM',
        layerName: 'vega-api:termo_embargo_ipaam',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        colorIcon: '#7078e4',
        opacidade: 100
    },
    {
        codigo: 'EMBARGOS_EMERGENCIAIS_IPAAM',
        nome: 'Embargos emergenciais - IPAAM',
        label: 'Embargos emergenciais - IPAAM',
        layerName: 'vega-api:embargos_emergenciais_ipaam',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        colorIcon: '#70cee4',
        opacidade: 100
    },
    {
        codigo: 'AUTOS_INFRACAO_FISCALIZACAO_IPAAM',
        nome: 'Autos de Infração de Fiscalização - IPAAM',
        label: 'Autos de Infração de Fiscalização - IPAAM',
        layerName: 'vega-api:autos_infracao_fiscalizacao_ipaam',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        colorIcon: '#70cee4',
        opacidade: 100
    },
    {
        codigo: 'EMBARGOS_REMOTOS_IPAAM',
        nome: 'Embargos remotos - IPAAM',
        label: 'Embargos remotos - IPAAM',
        layerName: 'vega-api:embargos_remotos_ipaam',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        colorIcon: '#3a6c77',
        opacidade: 100
    },
    {
        codigo: 'AUTO_INFRACAO_GO_PONTO',
        nome: 'Auto Infração GO Ponto',
        label: 'Auto Infração GO Ponto',
        layerName: 'vega-api:auto_infracao_go_ponto',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        colorIcon: '#ff0000',
        opacidade: 100
    },
    {
        codigo: 'AREA_EMBARGADA_PARANA',
        nome: 'Áreas Embargadas Paraná',
        label: 'Áreas Embargadas Paraná',
        layerName: 'vega-api:area_embargada_parana',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        colorIcon: '#FF0000',
        opacidade: 100
    },
    {
        codigo: 'TREE_CANOPY_COVER_TCC',
        nome: 'Tree canopy cover (TCC)',
        label: 'Tree canopy cover (TCC)',
        layerName: 'vega-api:tree_canopy_cover',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        opacidade: 100,
        colorIcon: '#e69138'
    },
    {
        codigo: 'AREA_EMBARGADA_AUTO_INFRACAO_SP',
        nome: 'Áreas Embargadas - Autos de infração SP',
        label: 'Áreas Embargadas - Autos de infração SP',
        layerName: 'vega-api:area_embargada_auto_infracao_sp',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        colorIcon: '#FF0000',
        opacidade: 100,
        cql_filter: "sede='Não'"
    },
    {
        codigo: 'AREA_EMBARGADA_RS',
        nome: 'Áreas Embargadas - RS',
        label: 'Áreas Embargadas - RS',
        layerName: 'vega-api-homolog:area_embargada_rs',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api-homolog/wms',
        colorIcon: '#FF0000',
        opacidade: 100
    },
    {
        codigo: 'CSA_CERRADO',
        nome: 'CSA Cerrado',
        label: 'CSA Cerrado',
        layerName: 'vega-api:csa_cerrado',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        colorIcon: '#b21d11',
        opacidade: 100
    },
    {
        codigo: 'AREA_EMBARGADA_PA',
        nome: 'Áreas Embargadas - PA',
        label: 'Áreas Embargadas - PA',
        layerName: 'vega-api:areas_embargadas_pa',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        colorIcon: '#B21D11',
        opacidade: 100
    },
    {
        codigo: 'AUTO_INFRACAO_PI',
        nome: 'Auto de Infração - PI',
        label: 'Auto de Infração - PI',
        layerName: 'vega-api:auto_infracao_pi',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        colorIcon: '#FFFF00',
        opacidade: 100
    },
    {
        codigo: 'QUILOMBOLAS_MARANHAO',
        nome: 'Quilombolas - Maranhão',
        label: 'Quilombolas - Maranhão',
        layerName: 'vega-api:quilombolas_maranhao',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        colorIcon: '#c1b0ab',
        opacidade: 100
    },
    {
        codigo: 'QUILOMBOLAS_MARANHAO_BUFFER',
        nome: 'Quilombolas - Maranhão',
        label: 'Quilombolas - Maranhão',
        layerName: 'vega-api:quilombolas_maranhao_buffer',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        colorIcon: '#c1b0ab',
        opacidade: 100
    },
    {
        codigo: 'QUILOMBOLAS_BA',
        nome: 'Quilombolas - Bahia',
        label: 'Quilombolas - Bahia',
        layerName: 'vega-api-homolog:quilombolas_ba',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api-homolog/wms',
        colorIcon: '#70cee4',
        opacidade: 100
    },
    {
        codigo: 'AREAS_EMBARGADAS_TO',
        nome: 'Áreas Embargadas - TO',
        label: 'Áreas Embargadas - TO',
        layerName: 'vega-api:areas_embargadas_to',
        checkbox: true,
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        colorIcon: '#FF0000',
        opacidade: 100,
        inspecionar: true
    },
    {
        codigo: 'AREA_PLANTADA_BUNGE',
        nome: 'Área plantada soja 2023/2024',
        label: 'Área plantada soja 2023/2024',
        layerName: 'vega-api:area_plantada_bunge',
        checkbox: true,
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        colorIcon: '#FF0000',
        opacidade: 100,
        inspecionar: true
    },
    {
        codigo: 'AUTO_INFRACAO_TO',
        nome: 'Auto de Infração - TO',
        label: 'Auto de Infração - TO',
        layerName: 'vega-api:auto_infracao_to',
        checkbox: true,
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        colorIcon: '#FFFF00',
        opacidade: 100,
        inspecionar: true
    },
    {
        codigo: 'AUTO_INFRACAO_RS',
        nome: 'Auto de Infração - RS',
        label: 'Auto de Infração - RS',
        layerName: 'vega-api-homolog:auto_infracao_rs',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api-homolog/wms',
        colorIcon: '#c1b0ab',
        opacidade: 100
    },
    {
        codigo: 'AREA_EMBARGADA_GO_PONTO',
        nome: 'Área embargada GO - Ponto',
        label: 'Área embargada GO - Ponto',
        layerName: 'vega-api:area_embargada_go_ponto',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        colorIcon: '#FF0000',
        opacidade: 100
    },
    {
        codigo: 'AREA_PLANTADA_DESMATAMENTO_VEGA_A_PARTIR_2021',
        nome: 'Área Plantada Desmatamento Vega a partir de 2021',
        label: 'Área Plantada Desmatamento Vega a partir de 2021',
        layerName: 'vega-api:area_plantada_desmatamento_vega_a_partir_2021',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        opacidade: 100
    },
    {
        codigo: 'PLANTIO_DESMATAMENTO_RED_FLAG',
        nome: 'Red Flag - Plantio em desmatamento',
        label: 'Red Flag - Plantio em desmatamento',
        layerName: 'vega-api:plantio_desmatamento_red_flag',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        opacidade: 100
    },
    {
        codigo: 'AUTO_INFRACAO_GO_POLIGONO',
        nome: 'Auto Infração GO Polígono',
        label: 'Auto Infração GO Polígono',
        layerName: 'vega-api:auto_infracao_go_poligono',
        ativo: false,
        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
        colorIcon: '#7859C3',
        opacidade: 100
    }
];

export default camadas;
